import React from "react";

import "./typography.scss";

/*
 * Types
 */

type PageTitleProps = React.HTMLProps<HTMLHeadingElement>;

type SectionTitleProps = {
    readonly large?: boolean;
} & React.HTMLProps<HTMLHeadingElement>;

type SubTitleProps = React.HTMLProps<HTMLHeadingElement>;

type BodyProps = React.HTMLProps<HTMLParagraphElement>;

/*
 * Main
 */

export const PageTitle = (props: PageTitleProps): React.ReactElement => {
    const { children, ...rest } = props;

    return <h1 {...rest}>{children}</h1>;
};

export const SectionTitle = (props: SectionTitleProps): React.ReactElement => {
    const { children, large = false, ...rest } = props;

    return (
        <h2 className={large ? "large" : undefined} {...rest}>
            {children}
        </h2>
    );
};

export const SubTitle = (props: SubTitleProps): React.ReactElement => {
    const { children, ...rest } = props;

    return <h3 {...rest}>{children}</h3>;
};

export const Body = (props: BodyProps): React.ReactElement => {
    const { children, ...rest } = props;

    return <p {...rest}>{children}</p>;
};
